import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, shallowRef, watch } from 'vue'
import { Icons } from '../static/js/Icons'
import type { RouteLocationRaw } from 'vue-router'

interface IProps {
  name: string
  size?: string
  color?: string // If the color is set to 'inherit', it will use the parent text color as the fill color.
  stroke?: string // If the stroke is set to 'inherit', it will use the parent text color as the stroke color.
  autoWidth?: boolean
  to?: RouteLocationRaw
  hoverable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KIcon' },
  __name: 'KIcon',
  props: {
    name: {},
    size: { default: '24px' },
    color: { default: '' },
    stroke: { default: '' },
    autoWidth: { type: Boolean, default: false },
    to: { default: () => ({}) },
    hoverable: { type: Boolean, default: false }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v36e4030e": (sizeRef.value)
}))



const props = __props

const myComponent = shallowRef('')
const sizeRef = ref('')

const loadComponent = () => {
  myComponent.value = Icons.get(props.name) ?? ''
}

watch(
  () => [props.name],
  () => loadComponent(),
  { immediate: true },
)

watch(
  () => props.size,
  () => (sizeRef.value = props.size),
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (myComponent.value)
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass(["flex inline", [
      `svg-icon--${__props.color}`,
      `svg-icon--stroke-${__props.stroke}`,
      {
        'cursor-pointer': __props.to && Object.keys(__props.to).length,
        'icon-auto-width': __props.autoWidth,
        'k-icon__hoverable': __props.hoverable,
        'k-icon__hoverable--fill': __props.hoverable && __props.color,
        'k-icon__hoverable--stroke': __props.hoverable && __props.stroke,
      },
    ]]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.to && Object.keys(__props.to).length && _ctx.$router.push(__props.to))),
        innerHTML: myComponent.value
      }, null, 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})